export default {
  computed: {
    commonConfig() {
      return this.$store.state.config
    }
  }
}
